module.exports = __webpack_public_path__ + "img/pongal.289cceba.jpg";